import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import AirQualityIndexData from "../../Scripts/AppServiceContract/AirQualityIndexData";

export default class DashboardEditorVM extends EditorVMBase {

  Id: string;
  Min: number;
  Max: number;
  Name: string;
  ColorCode: string;
  Description: string;
  IsActive: boolean;
  BackgroundColorCode: string;
  AirQualityIndexLangData: any;

  constructor() {
    super();

  }

  LoadOriginalSource(originalSource: AirQualityIndexData) {
    this.Id = originalSource.Id;
    this.Min = originalSource.Min;
    this.Max = originalSource.Max;
    this.Name = originalSource.Name;
    this.ColorCode = originalSource.ColorCode;
    this.Description = originalSource.Description;
    this.IsActive = originalSource.IsActive;
    this.BackgroundColorCode = originalSource.BackgroundColorCode;
    this.AirQualityIndexLangData = originalSource.AirQualityIndexLangDatas;
  }

  SaveOriginalSource(originalSource: AirQualityIndexData) {
    originalSource.Id = this.Id;
    originalSource.Min = this.Min;
    originalSource.Max = this.Max;
    originalSource.Name = this.Name;
    originalSource.ColorCode = this.ColorCode
    originalSource.Description = this.Description;
    originalSource.IsActive = this.IsActive;
    originalSource.BackgroundColorCode = this.BackgroundColorCode;
    originalSource.AirQualityIndexLangDatas = this.AirQualityIndexLangData;
  }
}
